import React from 'react';
import PropTypes from 'prop-types';

import GlobalSearch from './../../../../shared/GlobalSearch';
import Panel from '../../../../shared/Panel';
import { search, searchPanel, noBottomPadding } from './styles.module.css';

const HeaderMenuSearch = (props) => {
  const { onSearchCloseClick } = props;

  return (
    <Panel hideTitle className={noBottomPadding}>
      <GlobalSearch
        autoFocus
        className={search}
        panelClass={searchPanel}
        fullBleed
        inPortal
        onClose={onSearchCloseClick}
        showCloseButton
        noShadow
      />
    </Panel>
  );
};

export default HeaderMenuSearch;

HeaderMenuSearch.propTypes = {
  onSearchCloseClick: PropTypes.func,
};

HeaderMenuSearch.defaultProps = {
  onSearchCloseClick: () => {},
};
